// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2z65x","content":"Consent_content__2nSNJ","footer":"Consent_footer__1gbmf"};